export type Severity = 'TRACE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'FATAL';
export type TelemetryContext = { serviceVersion: string; environment: string };
export type CanonicalEvent = Record<string, unknown> & {
  timestamp: string;
  'event.name': string;
  body: string;
  severity_text: Severity;
  'service.name': string;
  'cloudhouse.product': 'enterprise';
  'cloudhouse.component': string;
};

// Pure: build the canonical event per the observability standard (OTel semantic
// conventions + Cloudhouse additions; rule 3 requires `body`). No I/O. Never PII.
export function buildCanonicalEvent(
  name: string, body: string, fields: Record<string, unknown>, ctx: TelemetryContext, severity: Severity = 'INFO',
): CanonicalEvent {
  return {
    timestamp: new Date().toISOString(),
    'event.name': name,
    body,
    severity_text: severity,
    'service.name': 'enterprise-hub',
    'service.version': ctx.serviceVersion,
    'deployment.environment.name': ctx.environment,
    'cloudhouse.product': 'enterprise',
    'cloudhouse.component': 'enterprise-hub',
    ...fields,
  };
}
